import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { Constants } from '@utils/constants';
import { AppUtils } from '@utils/app.utils';
import { Auth2Service } from '@services/strategy-pattern-login/auth2.service';
import { AuthService } from '@auth/auth.service';
import { AuthenticationService } from '@services/authentication.service';
import { RecoverTypeEnum } from '@model/enum/recover-type.enum';

@Component({
  selector: 'app-update-password-negotiation',
  templateUrl: './update-password-negotiation.component.html'
})
export class UpdatePasswordNegotiationComponent implements OnInit {
  showpassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  model: any = {};
  errorMsg01: string = Constants.MSG03_FORGOT_ERROR;
  validPass = true;
  loading: boolean;
  showConfirm: boolean;
  passwordComplexyLength: boolean;
  passwordComplexySpecial: boolean;
  passwordComplexyNumber: boolean;
  passwordComplexyLetterUp: boolean;
  passwordComplexyLetterDown: boolean;
  passwordWeak: boolean;
  passwordMedium: boolean;
  passwordGood: boolean;
  passwordStrong: boolean;

  constructor(
    public dialogRef: MatDialogRef<UpdatePasswordNegotiationComponent>,
    private _configService: ConfigService,
    private _authenticationService: AuthenticationService,
    public _NotificationService: NotificationsService,
  ) { }

  closeClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.model.password = '';
    this.model.newPassword = '';
    this.model.confirmPassword = '';
    this.model.login = this._configService.getHbAccount();
  }

  togglePassword() {
    this.showpassword = !this.showpassword;
  }

  toggleNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  validatorPassword(value) {
    if (this.model.newPassword !== this.model.confirmPassword) {
      this.validPass = false;
    } else {
      this.validPass = true;
    }
  }

  validatorPassword2(value) {
    if (this.model.confirmPassword) {
      if (this.model.newPassword !== this.model.confirmPassword) {
        this.validPass = false;
      } else {
        this.validPass = true;
      }
    }
    if (value) {
      this.complexyPassoword(value);
    } else {
      this.passwordWeak = false;
      this.passwordMedium = false;
      this.passwordGood = false;
      this.passwordStrong = false;
      this.passwordComplexyLength = false;
      this.passwordComplexyNumber = false;
      this.passwordComplexySpecial = false;
      this.passwordComplexyLetterUp = false;
      this.passwordComplexyLetterDown = false;
    }
  }

  difusionChangePassword() {
    if (!this._configService.isUserAssessorLogged()) {
      this._authenticationService.difusionChangePassword(this.model.login, this.model.password, this.model.confirmPassword, false,
        RecoverTypeEnum.NEGOTIATION).subscribe(res => {
          if (res && (res.success === 'true' || res.status === true || Number(res.userStatus) === 5)) {
            this.showConfirm = true;
            this.loading = false;
            this.model = {};
          } else {
            this.loading = false;
            if (res && res.message) {
              this._NotificationService.error('', res.message);
            } else if (res && res.userStatusText) {
              this._NotificationService.error('', res.userStatusText);
            } else if (res && (!res.success || res.success === 'false')) {
              this._NotificationService.error('', Constants.MSG_LOGIN_MSG008);
            } else {
              this._NotificationService.error('', Constants.MSG_LOGIN_MSG003);
            }
            this.loading = false;
          }
        }, error => {
          this._NotificationService.error('', Constants.MSG_LOGIN_MSG003);
          this.loading = false;
        });
      }
  }

  validChar(e) {
    if (AppUtils.validCharSystem(e)) {
      this._NotificationService.warn('', 'Caracter (' + e.key + ') inválido.');
      return false;
    }
  }

  complexyPassoword(value) {
    if (value && value !== '') {
      const passwordComplexyLengthTemp = new RegExp('^(?=.{8,})').test(value);
      const passwordComplexySpecialTemp = new RegExp('^(?=.*[#$^+=!*()@%&])').test(value);
      const passwordComplexyNumberTemp = new RegExp('^(?=.*[0-9])').test(value);
      const passwordComplexyLetterUpTemp = new RegExp('^(?=.*[A-Z])').test(value);
      const passwordComplexyLetterDownTemp = new RegExp('^(?=.*[a-z])').test(value);
      if (passwordComplexyLengthTemp) {
        this.passwordComplexyLength = true;
      } else {
        this.passwordComplexyLength = false;
      }
      if (passwordComplexySpecialTemp) {
        this.passwordComplexySpecial = true;
      } else {
        this.passwordComplexySpecial = false;
      }
      if (passwordComplexyNumberTemp) {
        this.passwordComplexyNumber = true;
      } else {
        this.passwordComplexyNumber = false;
      }
      if (passwordComplexyLetterUpTemp) {
        this.passwordComplexyLetterUp = true;
      } else {
        this.passwordComplexyLetterUp = false;
      }
      if (passwordComplexyLetterDownTemp) {
        this.passwordComplexyLetterDown = true;
      } else {
        this.passwordComplexyLetterDown = false;
      }

      if (value.length >= 8 && passwordComplexyLengthTemp && passwordComplexyNumberTemp && passwordComplexyLetterUpTemp
        && passwordComplexyLetterDownTemp && passwordComplexySpecialTemp) {
        this.passwordWeak = true;
        this.passwordMedium = true;
        this.passwordGood = true;
        this.passwordStrong = true;
      } else if (value.length >= 8 && passwordComplexyLengthTemp && passwordComplexyNumberTemp
        && (passwordComplexyLetterUpTemp || passwordComplexySpecialTemp)) {
        this.passwordWeak = true;
        this.passwordMedium = true;
        this.passwordGood = true;
        this.passwordStrong = false;
      } else if (value.length >= 8 && passwordComplexyLengthTemp && passwordComplexyNumberTemp
        && (passwordComplexyLetterDownTemp || passwordComplexyLetterUpTemp)) {
        this.passwordWeak = true;
        this.passwordMedium = true;
        this.passwordGood = false;
        this.passwordStrong = false;
      } else {
        this.passwordWeak = true;
        this.passwordMedium = false;
        this.passwordGood = false;
        this.passwordStrong = false;
      }
    }
  }

}

